import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = { class: "mgm-text" };
const _hoisted_3 = { class: "mgm-title" };
const _hoisted_4 = { class: "mgm-subtitle" };
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useReferrals } from '@/composables/useReferrals';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGMInfoPanel',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        const { referrerCredit, refereeCredit, available, claimedCount, featureAvailable, loaded, getReferrals } = useReferrals();
        function formatMoney(amount) {
            // short + stripIfInteger: whole amounts render as "£5" (no decimals)
            return state.formatter.format(Number(amount) || 0, true, false);
        }
        onMounted(() => {
            if (!loaded.value)
                getReferrals();
        });
        return (_ctx, _cache) => {
            return (_unref(loaded) && _unref(featureAvailable) && (_unref(available) || _unref(claimedCount) > 0))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "mgm-panel",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/mymgm')))
                }, [
                    _createElementVNode("img", {
                        src: require('@/assets/mgm-avatar-blue.png'),
                        alt: "",
                        class: "mgm-avatar"
                    }, null, 8, _hoisted_1),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, "Give " + _toDisplayString(formatMoney(_unref(referrerCredit))) + ". Get " + _toDisplayString(formatMoney(_unref(refereeCredit))) + ".", 1),
                        _createElementVNode("p", _hoisted_4, "Invite a colleague and you’ll both get " + _toDisplayString(formatMoney(_unref(refereeCredit))) + " in Saved to Spend for vouchers.", 1)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
